module.exports = __webpack_public_path__ + "img/figure.d4a2f604.svg";